import NewsSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsSignalSubType";
import type { Translatable } from "app/pages/sales-intelligence/types";

export const getNewsSignalCategoryKey = (signalSubType: string): string => {
    if (signalSubType === NewsSignalSubType.AnyNews) {return "categories";}

    return `categories-${signalSubType.toLowerCase()}`;
};

export const matchNewsCategoryToName = (category: string): Translatable => {
    return { key: `si.signals.filters.categories.${category}` };
};
